import { render, staticRenderFns } from "./PrintSaleIndex.vue?vue&type=template&id=68235962&"
import script from "./PrintSaleIndex.vue?vue&type=script&lang=js&"
export * from "./PrintSaleIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports